export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ContactData.vue?vue&type=template&id=6db6e172"


//////////////////
// WEBPACK FOOTER
// ./src/components/Forms/ContactData.vue?vue&type=template&id=6db6e172
// module id = 1513
// module chunks = 31